.message {
  .progress {
    --progress-duration: attr(data-progress-duration ms, 100ms);
    --tblr-progress-bar-transition: width var(--progress-duration) linear;
  }
}

.toast-container {
  .message {
    &::before {
      background-color: white;
      border-radius: var(--tblr-alert-border-radius);
      content: '';
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: -1;
    }
  }
}
